<template>
  <div class="search-item" v-if="isMore||searchInput.isShow!==false">
    <div v-if="searchInput.searchType==='checkbox'">
      <el-checkbox v-model="input"
                   :true-label="searchInput.trueLabel"
                   :false-label="searchInput.falseLabel"
                   @change="pushTab"
                   style="margin: 0 15px;">{{ searchInput.name }}</el-checkbox>
    </div>
    <div v-else>
      <span>{{ searchInput.name }}</span>
      <slot name="searchItem" v-if="searchInput.searchType==='slot'"/>
      <template v-else>
        <el-input v-model="input" :placeholder="`请输入${searchInput.name}`"
                  v-if="isInput(searchInput.type)"
                  @keyup.enter.native="pushTab"/>
        <el-select v-if="typeObj[searchInput.type] === 1"
                   v-model="input"
                   :placeholder="`请选择${searchInput.name}`"
                   @change="pushTab">
          <el-option v-for="item in searchInput.selectList"
                     :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-radio-group v-model="input" v-if="typeObj[searchInput.type] === 4">
          <el-radio v-for="(item, index) in searchInput.selectList" :key="index" :label="index" @click.native.prevent="radioClick(index)">{{ item.label }}</el-radio>
        </el-radio-group>
        <el-date-picker v-if="typeObj[searchInput.type] === 2"
                        :clearable="false"
                        :editable="false"
                        @change="pushTab"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="daterange"
                        v-model="input"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        unlink-panels/>
      </template>
    </div>
  </div>
</template>

<script>/**
 * @description 查询输入组件
 * @author: 菩萨蛮
 * @date 2020/2/12 9:24 下午
 * @version V1.0.1
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 * V1.0.1 给出一个设置默认值的口子
 */

import SearchObj from './SearchObj';
import i18n from '../../../i18n/index';

export default {
  name: 'SearchItem',
  props: {
    searchInput: {
      type: Object,
      default: () => ({ type: 0 })
    },
    clear: Number,
    defaultValue: { type: null, default: '' },
    isMore: { type: Boolean, default: false }
  },
  created() {
    this.input = this.defaultValue;
    if (this.input !== '') {
      this.pushTab();
    }
  },
  watch: {
    clear() {
      this.input = '';
    },
    defaultValue() {
      this.input = this.defaultValue;
    }
  },
  data() {
    return {
      input: '',
      typeObj: {
        input: 0,
        select: 1,
        date: 2,
        slot: 3,
        radio: 4
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    isInput(type) {
      return type === undefined || !Object.keys(this.typeObj).includes(type) || type === 'input';
    },
    radioClick(index) {
      const { selectList } = this.searchInput;
      const oldInput = this.input;
      if (index === this.input) {
        this.input = '';
        this.$emit('closeTab', { param: selectList[oldInput].param });
      } else {
        this.input = index;
        this.pushTab();
      }
    },
    pushTab() {
      if (this.searchInput.type === 'radio') {
        const { type, name, selectList } = this.searchInput;
        this.$emit('pushTabTwo', new SearchObj(selectList[this.input].param, name, selectList[this.input].value, type, selectList[this.input].label).tags);
        return;
      }
      if (this.searchInput.searchType === 'checkbox') {
        const { type, param, name } = this.searchInput;
        if (this.input === this.searchInput.trueLabel) {
          this.$emit('pushTab', new SearchObj(param, name, this.input, type, `${this.input === this.searchInput.trueLabel ? i18n.t('search.yes') : i18n.t('search.no')}`).tags);
        } else {
          this.$emit('closeTab', { param });
        }
        return;
      }

      if (Array.isArray(this.input)) {
        const [start, end] = this.input;
        const { type, param, name } = this.searchInput;
        this.$emit('pushTab', new SearchObj(param, `${name}：${start}至${end}`, this.input, type, '').tags);
        return;
      }

      if (!this.utils.isEmpty(this.input)) {
        const { type, param, name, selectList } = this.searchInput;
        this.$emit('pushTab',
          new SearchObj(param, name,
            this.input, type,
            type === 'select' ? selectList.find(i => i.value === this.input).label : '')
            .tags);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input {
  width: 220px;
}

.search-item {
  display: inline-block;

  span {
    margin: 0 13px;
    font-size: 12px;
    font-weight: 500;
    color: #6a7079;
  }
}
</style>
